<script>
  import Tabata from "./Tabata.svelte";
  import Emom from "./Emom.svelte";
  import Amrap from "./Amrap.svelte";
  import Rft from "./Rft.svelte";
  import Container from "./Container.svelte";
  import {
    tabataSetup,
    emomSetup,
    amrapSetup,
    rftSetup,
  } from "./../utils/setup";

  export let urlParams;

  const navOptions = [
    {
      id: "1",
      tabindex: 2,
      page: "tabata",
      setup: tabataSetup,
      component: Tabata,
    },
    { id: "2", tabindex: 3, page: "emom", setup: emomSetup, component: Emom },
    {
      id: "3",
      tabindex: 4,
      page: "amrap",
      setup: amrapSetup,
      component: Amrap,
    },
    { id: "4", tabindex: 5, page: "rft", setup: rftSetup, component: Rft },
  ];

  let selected = navOptions[0];
  let intSelected = selected.id;

  if (urlParams.has("t")) {
    const type = urlParams.get("t").toLowerCase();
    const option = navOptions.find((o) => o.page === type);
    if (option) {
      selected = option;
      intSelected = selected.id;
      if (urlParams.has("s")) {
        selected.setup.setup.sets = urlParams.get("s");
      }
    }
  }

  function changeComponent(event) {
    selected = navOptions.find((o) => o.id === event.srcElement.id);
    intSelected = selected.id;
    urlParams = new URLSearchParams();
    if (selected.setup.setup.id) {
      selected.setup.setup.id = null;
    }
  }
</script>

<Container>
  <nav class="flex pt-1">
    {#each navOptions as option}
      <button
        tabindex={option.tabindex}
        aria-label="Navigate"
        on:click={changeComponent}
        id={option.id}
        class={intSelected === option.id
          ? "uppercase text-sm py-2 px-2 block hover:text-blue-500 focus:outline-none focus:text-blue-500 text-blue-500 border-b-2 font-medium border-blue-500"
          : "uppercase text-sm text-gray-600 py-2 px-2 block hover:text-blue-500 focus:outline-none focus:text-blue-500"}
      >
        {option.page}
      </button>
    {/each}
  </nav>
  <svelte:component
    this={selected.component}
    {...selected.setup}
    {urlParams}
    on:startWorkout
  />
</Container>
